import DocumentUpload from './DocumentUpload';

export default DocumentUpload;
